import A from './types';

const initialState = {
  uri: '',
  context: '',
  vid: '',
  show: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case A.MODAL_URI_CHANGED: {
      if (action.payload.context === true) {
        return {
          uri: action.payload.uri,
        };
      }
      return {
        uri: action.payload.uri,
        context: action.payload.context,
      };
    }
    case A.MODAL_URI_CLOSED: {
      if (state.uri !== action.payload.uri) {
        return null;
      }
      return {
        uri: null,
        context: null,
      };
    }
    case A.VIDEO_CHANGED: {
      return {
        vid: action.payload.vid,
        show: action.payload.show,
      };
    }
    case A.MODAL_URI_VERIFY_CLOSED: {
      if (state.uri !== action.payload) {
        return null;
      }
      return {
        uri: null,
        context: null,
      };
    }
  }

  return null;
};

export default {reducer, initialState};



// WEBPACK FOOTER //
// ./src/modules/modal/reducer.js